var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",class:_vm.btnClasses,attrs:{"type":_vm.type}},'component',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"-mt-e3"},[_vm._t("default")],2),_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }